export const P00058SpeedUnitEnum = [
  { ref: 0, label: 'P00058.installation.pompe.unit.percent' },
  { ref: 1, label: 'P00058.installation.pompe.unit.rpm' },
];
